import GeneratedMailDomainStore from "./generated/GeneratedMailDomainStore"

class MailDomainStore extends GeneratedMailDomainStore {

}

export const mailDomainStore = new MailDomainStore()
